<template>
  <div class="login-container">
    <div class="login-box">
      <h2>系统登录</h2>
      <div class="input-group">
        <input 
          type="text" 
          v-model="username" 
          placeholder="用户名"
          @keyup.enter="login"
        >
      </div>
      <div class="input-group">
        <input 
          type="password" 
          v-model="password" 
          placeholder="密码"
          @keyup.enter="login"
        >
      </div>
      <button @click="login" class="login-btn">登录</button>
      <p v-if="error" class="error-message">{{ error }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LoginComponent',
  data() {
    return {
      username: '',
      password: '',
      error: ''
    }
  },
  methods: {
    login() {
      // 这里设置一个简单的用户名和密码验证
      if (this.username === 'admin' && this.password === 'admin123') {
        // 登录成功，存储登录状态
        localStorage.setItem('isLoggedIn', 'true')
        // 跳转到主页
        this.$router.push('/')
      } else {
        this.error = '用户名或密码错误'
      }
    }
  }
}
</script>

<style scoped>
.login-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background-color: #f5f5f5;
}

.login-box {
  background: white;
  padding: 2rem;
  border-radius: 8px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  width: 100%;
  max-width: 400px;
}

h2 {
  text-align: center;
  color: #333;
  margin-bottom: 2rem;
}

.input-group {
  margin-bottom: 1rem;
}

input {
  width: 100%;
  padding: 0.8rem;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 1rem;
}

input:focus {
  outline: none;
  border-color: #2196F3;
}

.login-btn {
  width: 100%;
  padding: 0.8rem;
  background-color: #2196F3;
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 1rem;
  cursor: pointer;
  transition: background-color 0.3s;
}

.login-btn:hover {
  background-color: #1976D2;
}

.error-message {
  color: red;
  text-align: center;
  margin-top: 1rem;
}
</style> 